import { render, staticRenderFns } from "./OnlineRoomTemp.vue?vue&type=template&id=00d9472c"
import script from "./OnlineRoomTemp.vue?vue&type=script&lang=js"
export * from "./OnlineRoomTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports